<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BulkPopover from './BulkPopover.vue';

const props = defineProps({
  showResolve: { type: Boolean, default: true },
  showReopen: { type: Boolean, default: true },
  showSnooze: { type: Boolean, default: true },
});

const emit = defineEmits(['update', 'close']);

const { t } = useI18n();

// O tom do ícone diz o que a ação faz: resolver é teal (concluído), reabrir
// é azul (conversa), adiar é âmbar (prazo) — as mesmas cores do resto.
const acoes = computed(() =>
  [
    props.showResolve && {
      chave: 'resolved',
      icone: 'i-lucide-circle-check',
      tom: 'bup-ico--teal',
      rotulo: t('CONVERSATION.HEADER.RESOLVE_ACTION'),
    },
    props.showReopen && {
      chave: 'open',
      icone: 'i-lucide-rotate-ccw',
      tom: 'bup-ico--azul',
      rotulo: t('CONVERSATION.HEADER.REOPEN_ACTION'),
    },
    props.showSnooze && {
      chave: 'snoozed',
      icone: 'i-lucide-alarm-clock',
      tom: 'bup-ico--ambar',
      rotulo: t('BULK_ACTION.UPDATE.SNOOZE_UNTIL'),
    },
  ].filter(Boolean)
);

const updateConversations = chave => {
  if (chave === 'snoozed') {
    // "Adiar" abre as opções de tempo na barra de comandos, que já tem a
    // lista completa (1h, amanhã, semana que vem, data escolhida).
    const ninja = document.querySelector('ninja-keys');
    ninja?.open({ parent: 'bulk_action_snooze_conversation' });
  } else {
    emit('update', chave);
  }
};
</script>

<template>
  <BulkPopover
    :titulo="t('BULK_ACTION.UPDATE.CHANGE_STATUS')"
    @close="emit('close')"
  >
    <button
      v-for="acao in acoes"
      :key="acao.chave"
      type="button"
      class="advup-menu__item"
      @click="updateConversations(acao.chave)"
    >
      <i class="bup-ico" :class="[acao.icone, acao.tom]" aria-hidden="true" />
      {{ acao.rotulo }}
    </button>
  </BulkPopover>
</template>

<style scoped>
.bup-ico {
  flex-shrink: 0;
  font-size: var(--ico-2);
}

.bup-ico--teal {
  color: rgb(var(--teal-11));
}

.bup-ico--azul {
  color: rgb(var(--blue-11));
}

.bup-ico--ambar {
  color: rgb(var(--amber-11));
}
</style>
